<template>
  <div>
    <!-- eslint-disable vue/no-v-html -->
    <p
      :class="headlineClass"
      class="h3"
      :style="headlineStyle"
      v-html="headline"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'HeadlineH3' });

interface Props {
  headline: string;
  headlineClass?: string;
  headlineStyle?: string | null;
}
withDefaults(defineProps<Props>(), {
  headlineClass: '',
  headlineStyle: null,
});
</script>

<style scoped src="./headline-h3" />
